<form [formGroup]="form" (ngSubmit)="submitForm()" #formContainer>
    <div class="inp-field">
        <label
            >{{ selectedLanguage === "en" ? content.name : content.nameBm
            }}<span class="tw-text-red-400 tw-ml-[5px]">*</span></label
        >
        <input
            type="text"
            [placeholder]="
                selectedLanguage === 'en' ? content.name : content.nameBm
            "
            formControlName="name"
            [ngClass]="{
                'input-error':
                    form.get('name')?.touched && form.get('name')?.invalid
            }"
        />
        <div
            class="error"
            *ngIf="form.get('name')?.touched && form.get('name')?.invalid"
        >
            <mat-icon fontSet="material-icons-outlined">info</mat-icon>
            {{ selectedLanguage === "en" ? errors.name : errors.nameBm }}
        </div>
    </div>

    <div class="inp-field">
        <label
            >{{ selectedLanguage === "en" ? content.email : content.emailBm
            }}<span class="tw-text-red-400 tw-ml-[5px]">*</span></label
        >
        <input
            type="email"
            [placeholder]="
                selectedLanguage === 'en' ? content.email : content.emailBm
            "
            formControlName="email"
            [ngClass]="{
                'input-error':
                    form.get('email')?.touched && form.get('email')?.invalid
            }"
        />
        <div
            class="error"
            *ngIf="form.get('email')?.touched && form.get('email')?.invalid"
        >
            <mat-icon fontSet="material-icons-outlined">info</mat-icon>
            {{ selectedLanguage === "en" ? errors.email : errors.emailBm }}
        </div>
    </div>

    <div class="inp-field">
        <label
            >{{ selectedLanguage === "en" ? content.phone : content.phoneBm
            }}<span class="tw-text-red-400 tw-ml-[5px]">*</span></label
        >
        <input
            type="text"
            [placeholder]="
                selectedLanguage === 'en' ? content.phone : content.phoneBm
            "
            formControlName="phoneNumber"
            [ngClass]="{
                'input-error':
                    form.get('phoneNumber')?.touched &&
                    form.get('phoneNumber')?.invalid
            }"
        />
        <div
            class="error"
            *ngIf="
                form.get('phoneNumber')?.touched &&
                form.get('phoneNumber')?.invalid
            "
        >
            <mat-icon fontSet="material-icons-outlined">info</mat-icon>
            {{ selectedLanguage === "en" ? errors.phone : errors.phoneBm }}
        </div>
    </div>
    <div class="inp-field">
        <label>{{
            selectedLanguage === "en"
                ? content.projectTitle
                : content.projectTitleBm
        }}</label>
        <input
            type="text"
            [placeholder]="
                selectedLanguage === 'en'
                    ? content.projectTitle
                    : content.projectTitleBm
            "
            formControlName="projectTitle"
            [ngClass]="{
                'input-error':
                    form.get('projectTitle')?.touched &&
                    form.get('projectTitle')?.invalid
            }"
        />
        <div
            class="error"
            *ngIf="
                form.get('projectTitle')?.touched &&
                form.get('projectTitle')?.invalid
            "
        >
            <mat-icon fontSet="material-icons-outlined">info</mat-icon>
            {{
                selectedLanguage === "en"
                    ? errors.projectTitle
                    : errors.projectTitleBm
            }}
        </div>
    </div>
    <div class="inp-field">
        <label>{{
            selectedLanguage === "en"
                ? content.principalName
                : content.principalNameBm
        }}</label>
        <input
            type="text"
            [placeholder]="
                selectedLanguage === 'en'
                    ? content.principalName
                    : content.principalNameBm
            "
            formControlName="principalName"
            [ngClass]="{
                'input-error':
                    form.get('principalName')?.touched &&
                    form.get('principalName')?.invalid
            }"
        />
        <div
            class="error"
            *ngIf="
                form.get('principalName')?.touched &&
                form.get('principalName')?.invalid
            "
        >
            <mat-icon fontSet="material-icons-outlined">info</mat-icon>
            {{
                selectedLanguage === "en"
                    ? errors.principalName
                    : errors.principalNameBm
            }}
        </div>
    </div>

    <div class="inp-field">
        <label class="tw-mb-[15px]">
            {{
                selectedLanguage === "en"
                    ? content.insuranceType
                    : content.insuranceTypeBm
            }}
            <span class="tw-text-red-400 tw-ml-[5px]">*</span>
        </label>

        <div
            class="tw-grid lg:tw-grid-cols-2 tw-gap-[10px]"
            [ngClass]="{
                'checkbox-invalid':
                    form.get('typeOfInsurance')?.touched &&
                    form.get('typeOfInsurance')?.invalid
            }"
        >
            <div
                class="tw-text-[#7B7575]"
                *ngFor="let item of content.insuranceOptions; let i = index"
            >
                <label
                    class="tw-cursor-pointer !tw-text-[15px] custom-checkbox"
                    [for]="i"
                >
                    <input
                        [id]="i"
                        type="checkbox"
                        [value]="item.en"
                        (change)="onCheckboxChange($event)"
                    />
                    <span class="checkmark"></span>
                    {{ selectedLanguage == "en" ? item.en : item.bm }}
                </label>
            </div>
        </div>
        <div
            class="error !tw-ml-0"
            *ngIf="
                form.get('typeOfInsurance')?.touched &&
                form.get('typeOfInsurance')?.invalid
            "
        >
            <mat-icon fontSet="material-icons-outlined">info</mat-icon>
            {{
                selectedLanguage === "en"
                    ? errors.insuranceType
                    : errors.insuranceTypeBm
            }}
        </div>
    </div>

    <div>
        <div class="tw-flex tw-gap-[5px] tw-items-start">
            <input
                class="tw-mt-[3px]"
                type="checkbox"
                formControlName="termsConditions"
            />
            <span
                class="tw-text-[14px] tw-text-[#7B7575]"
                [innerHTML]="
                    selectedLanguage === 'en' ? content.terms : content.termsBm
                "
                ><span class="tw-text-red-400 tw-ml-[5px]">*</span></span
            >
        </div>
        <div
            class="error !tw-ml-[15px] !tw-mt-[7px]"
            *ngIf="
                form.get('termsConditions')?.touched &&
                form.get('termsConditions')?.invalid
            "
        >
            <mat-icon fontSet="material-icons-outlined">info</mat-icon>
            {{ selectedLanguage === "en" ? errors.terms : errors.termsBm }}
        </div>
    </div>

    <button
        ga-event-id="bizcare_submit_button_insurance_click"
        ga-event-category="Insurance Details Page Button"
        ga-event-label="Submit Button Click"
        ga-track="track"
        class="disabled:tw-opacity-70 tw-bg-[#FFA53C] tw-text-white tw-rounded-full md:tw-max-w-fit tw-px-[100px] tw-py-[13px]"
        type="submit"
    >
        {{ selectedLanguage === "en" ? "Submit" : "Hantar" }} >
    </button>
</form>
